export default {
  title: 'Payment',
  description: 'All transactions are secure and encrypted',
};
